// extracted by mini-css-extract-plugin
export var pageContainer = "_l-1";
export var settingsContent = "_l-0";